module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('home-footer-info'), _vm._v(" "), _c('home-tel'), _vm._v(" "), _c('home-about-us'), _vm._v(" "), _c('home-rights')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24402f00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeFooter.vue
// module id = 141
// module chunks = 1